import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  disabled?: boolean;
};

const FormCheckbox = ({ value, onChange, label, disabled = false }: Props) => {
  return (
    <Box
      sx={{
        cursor: disabled ? "default" : "pointer",
        display: "flex",
        gap: "4px",
        alignItems: "center",
        opacity: disabled ? 0.5 : 1,
      }}
      onClick={() => {
        if (disabled) return;
        onChange(!value);
      }}
    >
      <Checkbox
        sx={{ color: (theme) => theme.palette.chartFirstColor }}
        checked={!!value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <Typography sx={{ fontWeight: 500, fontSize: "12px" }}>
        {label}
      </Typography>
    </Box>
  );
};

export default FormCheckbox;
